import { ProspectoCab } from './../../../models/ProspectoCab';
import { FiltrosProspecto } from 'app/models/FiltrosProspecto';
import { DatePipe, DecimalPipe } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DateAdapter, MatPaginator, MatSort, MatTableDataSource, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import moment from 'moment';
import { MessagesDates, MessagesGeneral, MessagesStatus, MessagesTitles } from '../../../models/messages';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import Swal from 'sweetalert2';
import { ProspectosService } from 'app/services/operaciones/prospectos/prospectos.service';
import { Router } from '@angular/router';
import { LoginService } from 'app/services/login/login.service';
import { Subscription } from 'rxjs';
import * as XLSX from 'xlsx';
import { environment } from 'environments/environment';

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};
@Component({
  selector: 'app-listado-prospectos',
  templateUrl: './listado-prospectos.component.html',
  styleUrls: ['./listado-prospectos.component.scss'],
  providers: [MessagesTitles, MessagesGeneral, MessagesDates, MessagesStatus, DatePipe, DecimalPipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }]
})
export class ListadoProspectosComponent implements OnInit, OnDestroy {

  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  Label_Prospectos=environment.LABEL_PROSPECTOS;
  Label_Prospecto=environment.LABEL_PROSPECTO;
  Label_id_soles=environment.ID_GUIA_SOLES;
  DTOFiltrosProspecto: FiltrosProspecto = new FiltrosProspecto();
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  displayedColumns = ['checked', 'idPropuestaOperacion', 'idProspecto', 'Razon_Social_Adq', 'Ruc_Adquirente', 'Razon_Social_Prov',
    'Ruc_Proveedor', 'Moneda_Dsc', 'Monto_Comercial', 'Monto_Riesgo_Inicial', 'Monto_Riesgo_Ejecutado', 'Monto_Riesgo_Disponible',
    'Monto_Riesgo_Finalizado', 'Fecha_Registro', 'Nombre_Usuario_Comercial', 'Estado_Prospecto_Desc'];
  pageSizeOptions = [10, 20, 30, 50, 100, 200];
  fechaD: Date = new Date();
  fechaH: Date = new Date();
  flagEvaluarProspecto: boolean = false;
  flagEditarProspecto: boolean = false;
  loading: boolean;
  prospectos: ProspectoCab[] = [];
  dataSource: any;
  prospecto: any;
  value: any;
  subLista: Subscription[] = [];
  subProspecto: Subscription = new Subscription();

  constructor(
    private loginService: LoginService,
    private datepipe: DatePipe,
    private decimalPipe: DecimalPipe,
    private msgTitulos: MessagesTitles,
    private msgStatus: MessagesStatus,
    private prospectosService: ProspectosService,
    private router: Router
  ) {
    this.DTOFiltrosProspecto.FechaIni = this.datepipe.transform(moment().add(-30, 'day'), 'yyyy-MM-dd');
    this.DTOFiltrosProspecto.FechaFin = this.datepipe.transform(moment(), 'yyyy-MM-dd');
  }

  ngOnInit() {
    this.listadoProspectos();
  }

  ngOnDestroy() {
    this.subLista.forEach(sub => { sub.unsubscribe(); });
  }

  applyFilter(filterValue: string) {
    if (null != this.dataSource) {
      this.dataSource.filter = filterValue.trim().toLowerCase();
    }
  }

  ExportTOExcel() {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.prospectos);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    let fecha = new Date();
    XLSX.writeFile(wb, 'Reporte_Prospectos' + fecha + '.xlsx');
  }

  listadoProspectos() {
    this.loading = true;
    this.DTOFiltrosProspecto.FechaIni = this.datepipe.transform(this.DTOFiltrosProspecto.FechaIni, 'yyyy-MM-dd');
    this.DTOFiltrosProspecto.FechaFin = this.datepipe.transform(this.DTOFiltrosProspecto.FechaFin, 'yyyy-MM-dd');
    this.DTOFiltrosProspecto.Version = 2;
    this.subProspecto = this.prospectosService.obtenerProspectoCab(this.DTOFiltrosProspecto).subscribe(
      (resp: ProspectoCab[]) => {
        this.prospectos = resp;
        
        this.prospectos = this.ordenarProspectosPendientes(this.prospectos);
        
        this.prospectos.forEach(p =>{
          if (p.Moneda_Dsc == 'SOLES') {
            p.edit = false;
          }
          
          p.Monto_Comercial = Number(p.Monto_Comercial).toFixed(2);
          p.Monto_Riesgo_Inicial = Number(p.Monto_Riesgo_Inicial).toFixed(2);
          p.Monto_Riesgo_Ejecutado = Number(p.Monto_Riesgo_Ejecutado).toFixed(2);
          p.Monto_Riesgo_Disponible = Number(p.Monto_Riesgo_Disponible).toFixed(2);
          p.Monto_Riesgo_Finalizado = Number(p.Monto_Riesgo_Finalizado).toFixed(2);
          p.Sum_VNPP = Number(p.Sum_VNPP).toFixed(2);
          
        })
        this.dataSource = new MatTableDataSource(this.prospectos);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.loading = false;
      },
      (err) => {
        this.loading = false;
        this.msgStatus.getMessage(err.status);
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "LISTA NO OBTENIDA. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
      }
    );

    this.subLista.push(this.subProspecto);
  }

  ordenarProspectosPendientes(arrProspectos: ProspectoCab[]) {
    let noPendientes: any[] = arrProspectos.filter(p => p.Estado != 'P').sort();
    let pendientes: any[] = arrProspectos.filter(p => p.Estado == 'P').sort();
    if (pendientes != []) {
      let totProspectos: any[] = [];
      pendientes.forEach(element => {
        noPendientes.unshift(element);
      });
      totProspectos = noPendientes;
      arrProspectos = totProspectos;
    }
    return arrProspectos;
  }

  abrirProspecto(prospecto: any) {
    this.prospecto = prospecto;
    this.prospecto.propuesta = false;
    this.prospecto.edit = false;
    this.flagEvaluarProspecto = true;
  }

  editarRespuesta(prospecto: any) {
    this.prospecto = prospecto;
    this.prospecto.edit = true;
    this.prospecto.propuesta = false;
    this.flagEditarProspecto = true;
  }

  metCerrarEvaluacionProspecto() {
    this.flagEvaluarProspecto = false;
    this.flagEditarProspecto = false;
    this.prospecto.propuesta = false;
    this.prospecto.edit = false;
    this.listadoProspectos();
  }

  refresh() {
    this.loginService.clickGuard = true;
    let currentUrl = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.loginService.clickGuard = true;
      this.router.navigate([currentUrl]);
    });
  }
}
